function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { withTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';
import styles from './styles';
const SelectInput = props => {
  return /*#__PURE__*/React.createElement(Select, _extends({}, props, {
    styles: styles(props),
    onClick: e => {
      e.stopPropagation();
    },
    className: "react-select-container",
    classNamePrefix: "react-select",
    formatOptionLabel: data => {
      return /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: data.label
        }
      });
    }
  }));
};
SelectInput.defaultProps = {
  hideSelectedOptions: false
};
SelectInput.propTypes = {
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  isMulti: PropTypes.bool.isRequired,
  hideSelectedOptions: PropTypes.bool
};
export default withTheme(SelectInput);